import { render, staticRenderFns } from "./ShiftHandoverModal.vue?vue&type=template&id=1fd66357&scoped=true&"
import script from "./ShiftHandoverModal.vue?vue&type=script&lang=js&"
export * from "./ShiftHandoverModal.vue?vue&type=script&lang=js&"
import style0 from "./ShiftHandoverModal.vue?vue&type=style&index=0&id=1fd66357&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd66357",
  null
  
)

export default component.exports